import React from 'react';

/**
 * VideoBackground Component
 * 
 * A responsive video background component that handles different videos for mobile and desktop
 * 
 * @param {Object} props
 * @param {string} props.mobileVideo - Path to the mobile video
 * @param {string} props.desktopVideo - Path to the desktop video
 * @param {React.ReactNode} props.children - Content to display over the video
 * @param {boolean} props.isMobile - Whether the current viewport is mobile
 */
const VideoBackground = ({ mobileVideo, desktopVideo, children, isMobile }) => {
  return (
    <section 
      className="relative w-full overflow-hidden" 
      style={{ aspectRatio: isMobile ? '9/16' : '16/9' }}
    >
      {/* Video background */}
      {isMobile ? (
        <video 
          key="mobile-video"
          className="absolute inset-0 w-full h-full object-cover z-0"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        >
          <source src={mobileVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <video 
          key="desktop-video"
          className="absolute inset-0 w-full h-full object-cover z-0"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        >
          <source src={desktopVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
      
      {/* Content container with adjusted padding */}
      <div className="absolute inset-0 z-20 flex flex-col px-2 sm:px-4 lg:px-6 py-12 sm:py-14 md:py-16 lg:py-20">
        {children}
      </div>

      {/* Custom CSS for specific breakpoint range */}
      <style jsx>{`
        @media (min-width: 640px) and (max-width: 720px) {
          .text-xl.sm\\:text-xl {
            font-size: 1rem !important; /* Even smaller for this specific range */
          }
          
          /* Make container width full for this range */
          .sm\\:w-\\[95\\%\\] {
            width: 100% !important;
          }
          
          /* Reduce padding to fit everything */
          .sm\\:py-14 {
            padding-top: 1.5rem !important;
            padding-bottom: 1.5rem !important;
          }
          
          /* Reduce word container height */
          .sm\\:h-10 {
            height: 2rem !important;
          }
          
          /* Make button text smaller */
          button {
            font-size: 0.75rem !important;
            padding-left: 0.5rem !important;
            padding-right: 0.5rem !important;
          }
          
          input {
            font-size: 0.75rem !important;
          }
        }
      `}</style>
    </section>
  );
};

export default VideoBackground;